module.exports = __webpack_public_path__ + "img/default.93323511.jpg";